import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { hasValueInList } from '../../../helpers/array';
import PermissoesHelper from '../../../helpers/PermissoesHelper';
import { useAuth } from '../../../security/authContext';
import Acessos from './Acessos';
import PreferenciasPlataforma from './Preferencias';
import { Grupo, PermissoesStyles } from './styles';

export default function Permissoes({
  selectedPermissions,
  setSelectedPermissions,
  withGroup,
  isDisabled,
}) {
  const [permissoesExistentes, setPermissoesExistentes] = useState({});
  const { user } = useAuth();

  useEffect(() => {
    async function getPermissoes() {
      const permissoes = await PermissoesHelper.getPermissoesAgrupadas(
        withGroup
      );

      if (user.profile === 'CLIENTE') {
        delete permissoes['Alternar login'];
        delete permissoes['Parametrização'];
      }

      setPermissoesExistentes(permissoes);
    }

    getPermissoes();
  }, [withGroup]);

  const onSelectPermission = selectedId => {
    const permissoes = hasValueInList(selectedPermissions, 'id', selectedId)
      ? selectedPermissions.filter(({ id }) => id !== selectedId)
      : [...selectedPermissions, { id: selectedId }];

    setSelectedPermissions(permissoes);
  };

  return (
    <>
      <PermissoesStyles />
      <Grupo>
        {withGroup ? (
          <PreferenciasPlataforma
            permissoesExistentes={permissoesExistentes}
            selectedPermissions={selectedPermissions}
            onSelectPermission={onSelectPermission}
            isDisabled={isDisabled}
          />
        ) : (
          <Acessos
            permissoesExistentes={permissoesExistentes}
            selectedPermissions={selectedPermissions}
            onSelectPermission={onSelectPermission}
            isDisabled={isDisabled}
          />
        )}
      </Grupo>
    </>
  );
}

Permissoes.propTypes = {
  selectedPermissions: PropTypes.instanceOf(Array),
  setSelectedPermissions: PropTypes.func.isRequired,
  withGroup: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

Permissoes.defaultProps = {
  selectedPermissions: [],
  withGroup: false,
  isDisabled: false,
};
